
export { CollectionName } from "/codebuild/output/src2228039058/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"